import { render, staticRenderFns } from "./SectionTitle.vue?vue&type=template&id=de42cd02&scoped=true"
import script from "./SectionTitle.vue?vue&type=script&lang=js"
export * from "./SectionTitle.vue?vue&type=script&lang=js"
import style0 from "./SectionTitle.vue?vue&type=style&index=0&id=de42cd02&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de42cd02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de42cd02')) {
      api.createRecord('de42cd02', component.options)
    } else {
      api.reload('de42cd02', component.options)
    }
    module.hot.accept("./SectionTitle.vue?vue&type=template&id=de42cd02&scoped=true", function () {
      api.rerender('de42cd02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Settings/SectionTitle.vue"
export default component.exports